import React, { useState, useContext } from 'react';

import {
    makeStyles,
    Button,
    TextField,
    Typography
} from '@material-ui/core'

import { api, PortalContext } from '@portal/arq-portal-core';
import { useSWRConfig } from 'swr';
import { FavoritosContext } from '../context/FavoritosContext';

const useEstilos = makeStyles(() => ({
    divExterior: {
        padding: '0 10px'
    },
    botones: {
        display: 'flex',
        justifyContent: 'end',
        height: '25px',
        marginTop: '20px'
    },
    textfield: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',

        '& .MuiInputBase-root': {
            borderRadius: '0px',
        },
    },
    label: {
        '&:after': {
            content: '" *"',
            color: 'red'
        }
    },
    inputCont: {
        '& .MuiInputBase-root': {
            borderRadius: '0px',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#606060 !important',
        },
    },
    input: {
        height: '10px',
        fontSize: '12px',

    },
    cancelar: {
        cursor: 'pointer',
        backgroundColor: 'white',
        color: '#606060',
        border: '2px solid #606060',
        borderRadius: '0px',
        width: '50%',
        fontSize: '12px',
        padding: '13px 15px',
        lineHeight: '14px',
        fontFamily: 'Catalana-sans, Arial, sans-serif',
        fontWeight: 900,
        '&:hover': {
            background: 'transparent',
            color: '#919191',
            border: '2px solid #919191',
        },
        '&:focus, &:active': {
            background: 'transparent',
            color: '#DC0028',
            border: '2px solid #DC0028',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
    },
    guardar: {
        cursor: 'pointer',
        backgroundColor: '#606060',
        color: 'white',
        marginLeft: '20px',
        borderRadius: '0px',
        width: '50%',
        fontSize: '12px',
        padding: '13px 15px',
        lineHeight: '14px',
        border: '2px solid #606060',
        fontFamily: 'Catalana-sans, Arial, sans-serif',
        fontWeight: 900,
        '&:hover': {
            background: '#919191',
            border: '2px solid #919191',
        },
        '&:focus, &:active': {
            background: '#DC0028',
            border: '2px solid #DC0028',
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '&.MuiButton-contained.Mui-disabled': {
            border: '2px solid #d6d8d8',
            background: '#d6d8d8',
            color: '#ffffff',
        }
    }
}));

interface Props {
    mostrarFormulario: (estado: boolean) => void;
}

export const AddEnlacePersonal = ({ mostrarFormulario }: Props) => {

    const clases = useEstilos();
    const [alias, setAlias] = useState('');
    const [url, setUrl] = useState('');
    const [validUrl, setValidUrl] = useState<boolean>(true);
    const helpInvalidURL:string = "La url ha de empezar por https:// o https://gestionanuevo.gco.global"; 
    const placeHolderURL:string = "https://www.example.com"

    const { mutate } = useSWRConfig();

    const { user } = useContext(PortalContext);
    const { favoritosSWRKey } = useContext(FavoritosContext);


    const cambioUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUrl(e.target.value);
        // let re = /^(https|http):\/\/\w$/;
        // let re=/^((https|http):\/\/)(www.)?[a-zA-Z0-9]+((\.[a-zA-Z0-9]{1,}){1,3})?(:[0-9])?(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
        let isValid = false;        
        ['https:\\\\', 'https://', 'http:\\\\', "https://gestionanuevo.gco.global"].forEach(x =>  {
            isValid = isValid || e.target.value.startsWith(x);
        });
        setValidUrl(isValid);
    };

    const cambioAlias = (e: any) => {
        setAlias(e.target.value);
    };

    const agregarEnlace = async (e: React.FormEvent) => {
        e.preventDefault();
        mutate([favoritosSWRKey, user?.id], () => api.post("/be/favsadd/", {
            Entrada: {
                Titulo: alias,
                Url: url,
                Tipo: 'Personales'
            }
        }), false);
        mostrarFormulario(false);
    };

    return (
        <div className={clases.divExterior}>
            <form onSubmit={agregarEnlace}>
                <div className={clases.textfield}>
                    <label htmlFor='url'> <Typography className={clases.label} variant='caption' component='span' >Url</Typography></label>
                    <TextField id='url' className={clases.inputCont} type='text' value={url} size='small' variant='outlined' placeholder={placeHolderURL} onChange={cambioUrl} InputProps={{ classes: { input: clases.input } }} error={!validUrl}  helperText={ validUrl?null:helpInvalidURL}/>
                </div>
                <div className={clases.textfield}>
                    <label htmlFor='alias'><Typography className={clases.label} variant='caption' component='span' >Alias</Typography></label>
                    <TextField id='alias' className={clases.inputCont} type='text' value={alias} size='small' variant='outlined' onChange={cambioAlias} InputProps={{ classes: { input: clases.input } }} />
                </div>
                <div className={clases.botones}>
                    <Button variant='outlined' className={clases.cancelar} disableElevation onClick={() => mostrarFormulario(false)}>
                        Cancelar
                    </Button>
                    <Button variant='contained' type='submit' className={clases.guardar} disableElevation disabled={url === '' || alias === '' || !validUrl}>
                        Guardar
                    </Button>
                </div>
            </form>
        </div>
    );
};
